import {DocumentNode} from 'graphql';
import React from 'react';

import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

interface QueryingOutputChipProps<TQuery, TVariables> {
  children: (data: TQuery) => JSX.Element | null;
  query: DocumentNode;
  variables: TVariables;
}

/**
 * Thin wrapper around `useBenchlingQuery` to query for chip popover content.
 */
export default function QueryingChipPopoverContent<TQuery, TVariables extends {}>(
  props: QueryingOutputChipProps<TQuery, TVariables>
): JSX.Element | null {
  const result = useBenchlingQuery<TQuery, TVariables>(props.query, {variables: props.variables});

  if (result.type === QueryResultType.PENDING) {
    return <HorizontalThrobber />;
  } else if (result.type === QueryResultType.ERROR) {
    return null;
  }

  return props.children(result.data);
}
